import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './addnew.css';

export default class AddNew extends Component {

	render() {
    console.log('add new button');
    return (
      <Link id="add-message" to="/add">Add new message</Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/addnew.jsx